import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_FINANCE = Symbol('finance');

export const ADMIN_FINANCE_ROUTE_NAME = Symbol('admin.finance');
export const AFFILIATE_FINANCE_ROUTE_NAME = Symbol('affiliate.finance');
export const ADMIN_FINANCE_LIST_ROUTE_NAME = Symbol('admin.finance.list');
export const AFFILIATE_FINANCE_LIST_ROUTE_NAME = Symbol('affiliate.finance.list');

export const FINANCE_LIST_API_URL_ADMIN = 'admin/bookkeepings/list_month_payments';
export const FINANCE_LIST_API_URL_AFFILIATE = 'affiliate/bookkeepings/list_affiliate_month_payments';

export const FINANCE_LIST_QUERY_KEY = 'finance.list';

export const FINANCE_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.BOOKKEEPINGS_SHOW, PermissionsList.affiliate.BOOKKEEPINGS_SHOW),
  REPORT: new Permission(PermissionsList.admin.BOOKKEEPINGS_DOWNLOAD_REPORT, PermissionsList.affiliate.BOOKKEEPINGS_DOWNLOAD_REPORT),
  DEDUCTION: new Permission(PermissionsList.admin.BOOKKEEPINGS_DEDUCTION),
  CHANGE_STATUS: new Permission(PermissionsList.admin.BOOKKEEPINGS_CHANGE_STATUS_MONTH_PAYMENT),
  TRANSFER_PAYMENT: new Permission(PermissionsList.admin.BOOKKEEPINGS_TRANSFER_PAYMENT),
  TRANSFER_PAYOFF: new Permission(PermissionsList.admin.BOOKKEEPINGS_TRANSFER_PAYOFF),
};
